__turbopack_context__.v({
  "container": "QuickSearchTabEmptyState-module__qb2Dbq__container",
  "content": "QuickSearchTabEmptyState-module__qb2Dbq__content",
  "textGroup": "QuickSearchTabEmptyState-module__qb2Dbq__textGroup",
});
